import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "content-box"
};
const _hoisted_2 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_cascader = _resolveComponent("el-cascader");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
    ref: "form",
    modelValue: _ctx.data.list,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.data.list = $event),
    class: "c-b-form"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.list, (rowItem, inde) => {
      return _openBlock(), _createElementBlock("div", {
        key: inde,
        class: "c-b-f-1-item"
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowItem, (colItem, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "c-b-f-2-item"
        }, [inde <= _ctx.data.isShowMore ? (_openBlock(), _createElementBlock("div", _hoisted_2, [colItem.type == 'ipt' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: colItem.label
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: colItem.value,
            "onUpdate:modelValue": $event => colItem.value = $event,
            modelModifiers: {
              trim: true
            },
            maxlength: "100",
            limit: "",
            style: {
              "width": "220px"
            },
            onInput: $event => _ctx.changComVal(colItem),
            onKeydown: _cache[0] || (_cache[0] = _withKeys(_withModifiers($event => _ctx.commonClick('enter'), ["prevent"]), ["enter"])),
            placeholder: colItem.placeholder
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput", "placeholder"])]),
          _: 2
        }, 1032, ["label"])) : _createCommentVNode("", true), colItem.type == 'sel' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 1,
          label: colItem.label
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: colItem.value,
            "onUpdate:modelValue": $event => colItem.value = $event,
            filterable: "",
            remote: "",
            clearable: "",
            "reserve-keyword": "",
            onChange: $event => _ctx.changComVal(colItem),
            "remote-method": query => {
              _ctx.getlist(query, colItem);
            },
            "popper-append-to-body": false,
            placeholder: "请输入..."
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colItem.list, (it, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: index,
                label: it.name,
                value: it.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "remote-method"])]),
          _: 2
        }, 1032, ["label"])) : _createCommentVNode("", true), colItem.type == 'cas' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 2,
          label: colItem.label
        }, {
          default: _withCtx(() => [_createVNode(_component_el_cascader, {
            modelValue: colItem.value,
            "onUpdate:modelValue": $event => colItem.value = $event,
            ref_for: true,
            ref: "getDom",
            onChange: $event => _ctx.selectProdcut(colItem),
            options: _ctx.data.options,
            props: _ctx.data.props,
            "show-all-levels": false,
            clearable: "",
            style: {
              "width": "220px"
            }
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "options", "props"])]),
          _: 2
        }, 1032, ["label"])) : _createCommentVNode("", true), colItem.type == 'spec' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 3
        })) : _createCommentVNode("", true), colItem.type == 'checkboxcontainer' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 4
        }, {
          default: _withCtx(() => [_createVNode(_component_el_checkbox, {
            modelValue: colItem.otherComponent.value,
            "onUpdate:modelValue": $event => colItem.otherComponent.value = $event,
            onChange: $event => _ctx.changComVal(colItem.otherComponent),
            "true-label": "1",
            "false-label": "0"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(colItem.otherComponent.name), 1)]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"]), _createVNode(_component_el_checkbox, {
            modelValue: colItem.otherchekbox.value,
            "onUpdate:modelValue": $event => colItem.otherchekbox.value = $event,
            onChange: $event => _ctx.changComVal(colItem.otherchekbox),
            "true-label": "1",
            "false-label": "0"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(colItem.otherchekbox.name), 1)]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])]),
          _: 2
        }, 1024)) : _createCommentVNode("", true), colItem.type == 'date' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 5,
          label: colItem.label
        }, {
          default: _withCtx(() => [_createVNode(_component_el_date_picker, {
            modelValue: colItem.value,
            "onUpdate:modelValue": $event => colItem.value = $event,
            type: "date",
            "value-format": "YYYY-MM-DD",
            placeholder: "请选择日期",
            "default-value": new Date(),
            onChange: $event => _ctx.changComVal(colItem)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "default-value", "onChange"])]),
          _: 2
        }, 1032, ["label"])) : _createCommentVNode("", true), colItem.type == 'searchReset' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 6,
          label: colItem.label
        }, {
          default: _withCtx(() => [_createElementVNode("span", {
            onClick: _cache[1] || (_cache[1] = (...args) => _ctx.getMoreSearch && _ctx.getMoreSearch(...args)),
            class: "bl-c m-r"
          }, "更多筛选"), _createVNode(_component_el_button, {
            class: _normalizeClass([colItem.otherComponent ? 'm-l' : '']),
            type: "primary",
            onClick: $event => _ctx.commonClick('search', colItem.url, colItem.otherValue)
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("搜索")])),
            _: 2,
            __: [3]
          }, 1032, ["class", "onClick"]), _createVNode(_component_el_button, {
            type: "primary",
            onClick: $event => _ctx.commonClick('reset', colItem.url, colItem.otherValue)
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("重置")])),
            _: 2,
            __: [4]
          }, 1032, ["onClick"])]),
          _: 2
        }, 1032, ["label"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
      }), 128))]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"])]);
}